import React, { useEffect, useState } from "react";
import logo from "../../Image/logo.png";

const CSS = `
  @keyframes splash-fade-in {
    from { opacity: 0; transform: scale(0.92); }
    to   { opacity: 1; transform: scale(1); }
  }
  @keyframes splash-fade-out {
    from { opacity: 1; }
    to   { opacity: 0; }
  }
  @keyframes splash-bar {
    from { width: 0%; }
    to   { width: 100%; }
  }
  .splash-enter { animation: splash-fade-in 0.5s cubic-bezier(.22,1,.36,1) both; }
  .splash-exit  { animation: splash-fade-out 0.4s ease both; }
  .splash-bar   { animation: splash-bar 1.8s cubic-bezier(.4,0,.2,1) both; }
`;

const SplashScreen = ({ onDone }) => {
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    const exitTimer = setTimeout(() => setExiting(true), 1800);
    const doneTimer = setTimeout(() => onDone(), 2200);
    return () => { clearTimeout(exitTimer); clearTimeout(doneTimer); };
  }, [onDone]);

  return (
    <>
      <style>{CSS}</style>
      <div
        className={exiting ? "splash-exit" : "splash-enter"}
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 9999,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          background: "#07090f",
          fontFamily: "'Plus Jakarta Sans', Inter, sans-serif",
        }}
      >
        {/* Ambient glow */}
        <div style={{
          position: "absolute",
          inset: 0,
          background: "radial-gradient(ellipse 60% 40% at 50% 50%, rgba(99,102,241,0.1), transparent)",
          pointerEvents: "none",
        }} />

        <img
          src={logo}
          alt="Cloudwalker"
          style={{
            height: 52,
            objectFit: "contain",
            filter: "drop-shadow(0 0 20px rgba(99,102,241,0.6))",
            marginBottom: "1.25rem",
          }}
        />

        <p style={{ color: "#1f2937", fontSize: "0.75rem", fontWeight: 600, letterSpacing: "0.15em", textTransform: "uppercase" }}>
          Catalog Builder
        </p>

        {/* Progress bar */}
        <div style={{
          marginTop: "2.5rem",
          width: 160,
          height: 2,
          borderRadius: 99,
          background: "rgba(255,255,255,0.05)",
          overflow: "hidden",
        }}>
          <div
            className="splash-bar"
            style={{ height: "100%", borderRadius: 99, background: "linear-gradient(to right, #4f46e5, #818cf8)" }}
          />
        </div>
      </div>
    </>
  );
};

export default SplashScreen;
